<template>
  <div class="card_wrap">
    <div class="card">
      <div class="top">
        <div class="title">{{ title }}</div>
        <button @click="$emit('delete')">
          <img src="../../../assets/images/icons/trash.svg" alt="">
        </button>
      </div>
      <div class="date">{{ date }}</div>
      <div class="desc">{{ desc }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Rent_Checkout_Card',
  props: {
    title: String,
    date: String,
    desc: String
  }
}
</script>

<style scoped lang="scss">
  .card {
    background-color: #fff;
    padding: 15px 20px 20px 20px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04);
    &_wrap {
      padding: 10px;
    }
  }

  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  button {
    border: none;
    background-color: transparent;
    width: 20px;
    height: 20px;
  }

  .title {
    font-family: "Open Sans", sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 1.5;
    color: #383838;
  }

  .date {
    margin: 5px 0;
  }

  .date, .desc {
    font-family: "Open Sans", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 1.71;
    color: #808080;
  }
</style>
